import PoolDevice from "./base";
import { DisplayProcessingLogics, StatesToDisplayItem } from "../Types";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";


export default class PoolDeviceCover extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 6;
    static CanBeAddedToflow = false;
    static DeviceType = DeviceTypes.COVER;
    static Icon = "pool-cover";
    static PickerTitle = Locale.gettext("Cover Sensor");
    
    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Cover": return Locale.gettext("Cover");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    getMainMetricField(): StatesToDisplayItem {
        let order = 0;
        return {
            Name: PoolsideDaemonDeviceStateNames.State,
            DisplayName: "Cover",
            DisplayNameShort: "Cover",
            DisplayOrder: ++order,
            DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
            DisplayProcessingLogicUnitAsDisplayName: false,
        };
    }    
}


export enum PoolsideDaemonDeviceStateNames {
    State = "State"
}
